import Vue from "vue";
import register from "../utils/register.js";
import directive from "../utils/directive.js";
import methods from "../utils/methods";
import '../assets/css/app.css'
Vue.use(methods);
Vue.use(register);
Vue.use(directive);



// WEBPACK FOOTER //
// ./src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/config/init.js